export function capitalizeFirstLetter(value: string) {
  return value[0].toUpperCase() + value.slice(1);
}
